import { Header } from '@/src/elements/header'
import { Stack } from '@/src/elements/navigation/Stack'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'

type TMinimalLayoutProps = {
  title: string
  fallbackRoute?: string
}

export const MinimalLayout = ({ fallbackRoute, title }: TMinimalLayoutProps) => {
  const { routes } = useRoutes()
  const { handleBackPress } = useBackHandlePress(fallbackRoute || routes['prayer-space']())

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        animation: 'slide_from_right',
        header: () => (
          <Header
            title={title}
            leftButtons={[
              {
                type: 'icon',
                startIcon: ICON.ARROW_LEFT,
                onPress: handleBackPress,
              },
            ]}
            className="pr-16"
          />
        ),
      }}
    />
  )
}
